<template>
  <div class="page-scene">
    <div class="standart-navigation">
      <h1>{{ $tr('help.title') }}</h1>
    </div>
    <template v-if="!managerInfoLoading && compoundName">
      <h2>{{ $tr('help.personalManager') }}</h2>
      <span v-html="compoundName"></span>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'help-scene',

    computed: {
      managerInfoLoading () {
        return this.managerInfo ? this.managerInfo.loading : null
      },

      managerEmail () {
        return this.managerInfo ? this.managerInfo.email : ''
      },

      managerPhone () {
        return this.managerInfo ? this.managerInfo.phone : ''
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      managerName () {
        if (!this.managerInfo) {
          return ''
        }

        const lastName = this.managerInfo.last_name
        const firstName = this.managerInfo.first_name
        const secondName = this.managerInfo.second_name

        if (!this.is_japan_locale) {
          return [firstName, secondName, lastName].filter(v => !!v).join(' ')
        }

        return [lastName, firstName].filter(v => !!v).join(' ')
      },

      compoundName () {
        return [this.managerName, this.managerPhone, this.managerEmail].filter(v => !!v).join('<br/>')
      },

      managerInfo () {
        const state = this.$store.state.managers

        return state ? state.data : null
      }
    },

    beforeMount () {
      this.$store.dispatch('managers/fetchPersonalManagerInfo')
    }
  }
</script>
